import { privateApi as api } from './privateApi';
export const addTagTypes = ['Privates'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      addPrivate: build.mutation<AddPrivateApiResponse, AddPrivateApiArg>({
        query: queryArg => ({
          url: `/private`,
          method: 'POST',
          body: queryArg.createPrivate
        }),
        invalidatesTags: ['Privates']
      }),
      bulkCreatePrivate: build.mutation<
        BulkCreatePrivateApiResponse,
        BulkCreatePrivateApiArg
      >({
        query: queryArg => ({
          url: `/private/bulk-create`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['Privates']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type AddPrivateApiResponse =
  /** status 201 Private has been created successfully. */ {
    ok?: boolean;
    data?: Private;
    message?: string;
  };
export type AddPrivateApiArg = {
  /** Private that needs to be added to the application */
  createPrivate: CreatePrivate;
};
export type BulkCreatePrivateApiResponse =
  /** status 201 Assets have been marked as private successfully. */ {
    ok?: boolean;
    data?: {
      success?: boolean;
    };
    message?: string;
  };
export type BulkCreatePrivateApiArg = {
  /** Subscriber ID and array of asset IDs to mark as private */
  body: {
    assetIds?: string[];
    subscriberId?: string;
  };
};
export type Private = {
  count?: number;
  rows?: {
    id: string;
    subscriberId: string;
    assetId: string;
    status: string;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
  }[];
};
export type CreatePrivate = {
  id: string;
  subscriberId: string;
  status: string;
  assetId: string;
  createdBy: string;
};
export const { useAddPrivateMutation, useBulkCreatePrivateMutation } =
  injectedRtkApi;
